<!-- 查询车辆信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
                requestBody: {
                      "parkCode": "PS0AF53Q",
                      "openInvoiceInfo": {
                      "invoiceBillType": 0,
                        "invoiceAddr": "",
                        "invoicePhone": "",
                        "bankName": "",
                        "bankAccount": "",
                        "invoiceSerial": "1312",
                        "invoiceFrom": 3,
                        "userMobile": "3123123",
                        "invoiceType": 2,
                        "invoiceTitle": "21312",
                        "email": "1231312312"
                    },
                      "openInvoiceBillInfoList": [
                        {
                          "billCode": "2023041915311325468244",
                          "billType": 0
                        }
                      ]
          },
            responseCode: {
                "data": {

                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,获取用户可开发票订单",
                t_url: this.commonUrls.test + "openInvoiceByPark",
                p_url: this.commonUrls.prod + "openInvoiceByPark",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                      titleName: null,
                      tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                      td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '账单对应的车场编码' },
                        { info1: 'openInvoiceInfo', info2: '是', info3: 'JSONObject', info4: '开票信息' },
                        { info1: 'openInvoiceBillInfoList', info2: '是', info3: 'JSONArray', info4: '开票时账单信息列表' },
                      ]
                    },{
                    titleName: "openInvoiceInfo 开票信息",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'invoiceType', info2: '是', info3: 'Integer', info4: '抬头类型0个人 1企业' },
                      { info1: 'invoiceTitle', info2: '是', info3: 'String', info4: '发票抬头' },
                      { info1: 'userMobile', info2: '否', info3: 'String', info4: '手机号码' },
                      { info1: 'email', info2: '是', info3: 'String', info4: '接收邮箱' },
                      { info1: 'invoiceValue', info2: '是', info3: 'String', info4: '发票金额' },
                      { info1: 'invoiceSerial', info2: '否', info3: 'String', info4: '纳税人识别号, invoiceType 为0 则不填，invoiceType 为1为 必填' },
                      { info1: 'invoiceAddr', info2: '否', info3: 'String', info4: '注册地址' },
                      { info1: 'invoicePhone', info2: '否', info3: 'String', info4: '注册手机' },
                      { info1: 'bankName', info2: '否', info3: 'String', info4: '开户银行' },
                      { info1: 'bankAccount', info2: '否', info3: 'String', info4: '银行账号' },
                      { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                      { info1: 'invoiceBillType', info2: '是', info3: 'Integer', info4: '0发票类型 0普票 1 专票)' },
                      { info1: 'invoiceFrom', info2: '是', info3: 'Integer', info4: '开票来源：0 游客开票 1一点停开票 2 aomp开票 3开放平台开票 4 pomp开票' },
                      { info1: 'orderType', info2: '是', info3: 'Integer', info4: '开票类型：0 合并开票 1 单独开票' },
                    ]
                },{
                  titleName: "openInvoiceBillInfoList 开票时账单信息列表",
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'billCode', info2: '是', info3: 'String', info4: '账单流水号' },
                    { info1: 'billType', info2: '是', info3: 'String', info4: '账单来源 0 停车缴费 1 月票缴费 2 优惠券缴费' },
                    { info1: 'invoiceValue', info2: '是', info3: 'String', info4: '发票金额' },
                  ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/openInvoiceByPark.vue